<!-- 服务客户/提升工作效率/降低运营成本 -->
<template>
    <div class="numberBox">
        <div class="number">
            <div class="number_item">
                <div class="numbox">
                    <animate-number class="num" ref="myNum1" from="0" to="10000" mode="manual" duration="3000"></animate-number>
                    <div class="symbol">+</div>
                </div>
                <div class="info">服务客户</div>
            </div>
            <div class="number_item">
                <div class="numbox">
                    <animate-number class="num" ref="myNum2" from="0" to="60" mode="manual" duration="3000"></animate-number>
                    <div class="percentage">%</div>
                    <div class="symbol">+</div>
                </div>
                <div class="info">提升工作效率</div>
            </div>
            <div class="number_item">
                <div class="numbox">
                    <animate-number class="num" ref="myNum3" from="0" to="70" mode="manual" duration="3000"></animate-number>
                    <div class="percentage">%</div>
                    <div class="symbol">+</div>
                </div>
                <div class="info">降低运营成本</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            flag: false,
        }
    },
    methods: {
        //监听窗口滚动
        windowScrollListener() {
            //获取操作元素最顶端到页面顶端的垂直距离
            let scrollTop = document.body.scrollTop || document.documentElement.scrollTop
            let numberBox = document.getElementsByClassName('numberBox')[0]
            let eleHeight = numberBox.offsetTop - 600

            if (scrollTop >= eleHeight) {
                if (!this.flag) {
                    this.flag = true
                    this.$refs.myNum1.start()
                    this.$refs.myNum2.start()
                    this.$refs.myNum3.start()
                }
            }
        },
    },
    mounted() {
        //在窗口滚动时调用监听窗口滚动方法
        window.addEventListener('scroll', this.windowScrollListener, false)
    },
    destroyed() {
        //离开页面时删除该监听
        window.removeEventListener('scroll', this.windowScrollListener)
    },
}
</script>
<style scoped lang="scss">
.numberBox {
    width: 100%;
    height: 190px;
    margin-top: 70px;
    background-color: #fff;

    .number {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;

        .number_item {
            width: 381px;
            height: 190px;
            padding: 25px 0 0 40px;
            box-sizing: border-box;
            border-radius: 6px;

            .numbox {
                display: flex;

                .num,
                .percentage {
                    height: 70px;
                    font-size: 50px;
                    font-family: Alibaba PuHuiTi 2-105 Heavy, Alibaba PuHuiTi 20;
                    font-weight: 900;
                    color: #be1a21;
                    line-height: 70px;
                }

                .symbol {
                    height: 56px;
                    font-size: 40px;
                    font-family: Alibaba PuHuiTi 2-105 Heavy, Alibaba PuHuiTi 20;
                    font-weight: 900;
                    color: #be1a21;
                    line-height: 56px;
                }
            }

            .info {
                margin-left: 5px;
                text-align: left;
                margin-top: -6px;
                height: 22px;
                font-size: 16px;
                font-family: Alibaba PuHuiTi 2-55 Regular, Alibaba PuHuiTi 20;
                font-weight: 400;
                color: #424242;
                line-height: 22px;
            }
        }

        .number_item:nth-child(1) {
            background: url('../../../assets/image/home/number_img1.png') no-repeat;
            background-size: 100% 100%;
        }

        .number_item:nth-child(2) {
            background: url('../../../assets/image/home/number_img2.png') no-repeat;
            background-size: 100% 100%;
        }

        .number_item:nth-child(3) {
            background: url('../../../assets/image/home/number_img3.png') no-repeat;
            background-size: 100% 100%;
        }
    }
}
</style>
